<template>
    <div class="modal fade modal-payform"
         id="modal-payform"
         tabindex="-1"
         role="dialog"
         style=""
         aria-modal="false">
        <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" role="document">
                <div class="modal-header d-flex align-items-center justify-content-between">
                    <h2 class="mb-0 h5"> {{__('payment.method_payments')}}</h2>
                    <button type="button"
                            class="btn-close"
                            data-bs-target="#modal-payform"
                            data-bs-toggle="modal"
                            aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex flex-column">
                                <h3 class="h6 font-18">
                                    {{__('payment.tc_td')}}
                                </h3>
                                <div class="border rounded py-3 px-3 d-flex justify-content-between gap-2 align-items-center flex-wrap mb-2">
                                    <div class="d-flex gap-1">
                                        <p class="mb-0">{{__('payment.until')}}</p>
                                        <strong class="text-success">36 {{__('payment.quotas')}}*</strong>
                                    </div>
                                    <div class="d-inline-flex align-items-center justify-content-center flex-wrap logos-ba">
                                        <div class="d-flex gap-4 flex-wrap justify-content-left justify-content-lg-center align-items-center">
                                            <div>
                                                <img src="/assets/img/tiquetesbaratos/img-visa.svg" />
                                            </div>
                                            <div>
                                                <img src="/assets/img/tiquetesbaratos/img-americanexpress.svg" />
                                            </div>
                                            <div>
                                                <img src="/assets/img/tiquetesbaratos/img-mastercard.svg" />
                                            </div>
                                            <div>
                                                <img src="/assets/img/tiquetesbaratos/img-maestro.svg" />
                                            </div>
                                            <div>
                                                <img class="w-100"
                                                     src="/assets/img/tiquetesbaratos/img-dinnerclub.svg" />
                                            </div>
                                            <div>
                                                <img src="/assets/img/tiquetesbaratos/img-visa-electron.svg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <small>
                                    *{{__('payment.payments_options')}}
                                </small>
                            </div>
                        </div>

                        <hr class="my-3" />
                        <div class="d-flex flex-column gap-2 col-12">
                            <div>
                                <h3 class="mb-0 h6 font-18">
                                    {{__('payment.have_credit_card')}}
                                </h3>

                                <p class="m-0 text-md gray-dark-color">
                                    {{__('payment.more_payments_methods')}}
                                </p>
                            </div>
                            <div class="border rounded">
                                <div class="py-3 px-3 d-flex justify-content-between align-items-center flex-wrap border-bottom gap-3">
                                    <div class="col-md-9">
                                        <p class="mb-0 font-bold">{{__('payment.bancolombia_btn')}}</p>
                                        <p class="m-0">
                                            {{__('payment.bancolombia_pay_online')}}
                                        </p>
                                    </div>
                                    <img loading="lazy"
                                         src="https://3.cdnpt.com/images/bancos/logo-bancolombia.png"
                                         alt="bancolombia"
                                         width="150"
                                         height="50" />
                                </div>
                                <div class="py-3 px-3 d-flex justify-content-between align-items-center flex-wrap border-bottom gap-3">
                                    <div class="col-md-10">
                                        <p class="mb-0 font-bold">{{__('payment.PSE_payment')}}</p>
                                        <p class="m-0">
                                            {{__('payment.PSE_pay_online')}}
                                        </p>
                                    </div>
                                    <img loading="lazy"
                                         src="https://3.cdnpt.com/images/bancos/logo-pse.svg"
                                         alt="PSE"
                                         width="60"
                                         height="60" />
                                </div>
                                <div class="py-3 px-3 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-md-center flex-wrap border-bottom gap-3">
                                    <p class="mb-0 font-bold">DaviPlata</p>
                                    <img loading="lazy"
                                         src="https://3.cdnpt.com/images/bancos/logo-daviplata.svg"
                                         alt="daviplata"
                                         width="90"
                                         height="60" />
                                </div>
                                <div class="py-3 px-3 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-md-center flex-wrap gap-3">
                                    <p class="mb-0 font-bold">Nequi</p>
                                    <img loading="lazy"
                                         src="https://3.cdnpt.com/images/bancos/logo-nequi.svg"
                                         alt="nequi"
                                         width="90"
                                         height="60" />
                                </div>
                            </div>
                        </div>
                        <hr class="my-3" />
                        <div class="d-flex flex-column gap-2 col-12">
                            <div>
                                <h3 class="mb-0 h6 font-18">{{__('payment.cash')}}</h3>

                                <p class="m-0 text-md gray-dark-color">
                                    {{__('payment.pay_cash')}}
                                </p>
                            </div>
                            <div class="border rounded">
                                <div class="py-3 px-3 d-flex justify-content-between align-items-center flex-wrap border-bottom gap-3">
                                    <div class="col-md-10">
                                        <p class="mb-0 font-bold">Efecty</p>
                                        <p class="m-0">
                                            {{__('payment.effecty_pay')}}
                                        </p>
                                    </div>
                                    <img loading="lazy"
                                         src="https://3.cdnpt.com/images/bancos/logo-efecty.svg"
                                         alt="efecty"
                                         width="60"
                                         height="60" />
                                </div>
                                <div class="py-3 px-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
                                    <div class="col-md-5 col-lg-6">
                                        <p class="mb-0 font-bold">{{__('payment.bank_deposit')}}</p>
                                        <p class="m-0">
                                            {{__('payment.deposit_pay')}}
                                        </p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-start flex-wrap">
                                        <img loading="lazy"
                                             src="https://3.cdnpt.com/images/bancos/logo-bancodebogota.svg"
                                             alt="banco de bogota"
                                             width="120"
                                             height="60" />
                                        <img loading="lazy"
                                             src="https://3.cdnpt.com/images/bancos/bancolombia.png"
                                             alt="banco de colombia"
                                             width="110"
                                             height="60" />
                                        <img loading="lazy"
                                             src="https://3.cdnpt.com/images/bancos/davivienda.png"
                                             alt="daviplata"
                                             width="110"
                                             height="60" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      pt: window.__pt,
    };
  },
  methods: {},
};
</script>
